// extracted by mini-css-extract-plugin
module.exports = {"goal":"Show-module__goal___3xnEg Fonts-module__h2___2NkLQ","complete":"Show-module__complete___3jfeB","new":"Show-module__new___3QKeK"};